module.exports = __webpack_public_path__ + "img/98.7763dc6b.jpg";